import { render, staticRenderFns } from "./MedOnboardForm.vue?vue&type=template&id=2fe0997f&scoped=true&"
import script from "./MedOnboardForm.vue?vue&type=script&lang=js&"
export * from "./MedOnboardForm.vue?vue&type=script&lang=js&"
import style0 from "./MedOnboardForm.vue?vue&type=style&index=0&id=2fe0997f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0997f",
  null
  
)

export default component.exports